import React, { useState } from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import classnames from 'classnames';
import Tooltip from '../Tooltip/Tooltip';
import Icons from 'components/Icons';
import ButtonExpand from '../ButtonExpand/ButtonExpand';

const useStyles = makeStyles({
  mainWrapper: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
    background: '#FFFEFE',
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)',
    borderRadius: ' 25px'
    // overflow: 'hidden' commented out because casuing issues in a few places
  },
  headerBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '1rem',
    position: 'relative',
    minHeight: '71px'
  },
  headerClickable: {
    cursor: 'pointer'
  },
  heightAuto: {
    height: 'auto'
  },
  noBorder: {
    borderBottom: 'none',
    height: 'initial',
    minHeight: 'initial',
    padding: '1rem'
  },
  title: {
    fontSize: '1.1rem',
    lineHeight: '1.3rem',
    fontWeight: 600,
    whiteSpace: 'nowrap'
  },
  info: {
    margin: '0 1rem 0.5rem'
  },
  iconBox: {
    width: '69px',
    height: '100%',
    backgroundColor: 'red',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '1rem',
    marginLeft: '-1rem'
  },
  subHeader: {
    minHeight: '4.125rem',
    display: 'flex',
    alignItems: 'center',
    padding: '0 1rem',
    borderBottom: '1px solid #eaeaea'
  },
  img: {
    height: '25px',
    width: '25px',
    position: 'absolute',
    right: '12px',
    cursor: 'pointer'
  },
  sub: {
    margin: '1rem auto',
    maxWidth: 'calc(100% - 2rem)',
    backgroundColor: '#f9f9f9'
  }
});

interface Props {
  children: any;
  title?: any;
  subTitle?: any;
  headerChildren?: any;
  className?: string;
  style?: any;
  info?: any;
  icon?: any;
  iconBg?: string;
  tooltip?: any;
  subHeader?: any;
  helperText?: any;
  closeModal?: Function;
  footer?: string;
  noBorder?: boolean;
  unrestrictHeaderHeight?: boolean;
  wrap?: boolean;
  dropdown?: boolean;
  item?: boolean;
  alignHeaderChildrenLeft?: boolean;
}

const BoxWrapper = ({
  children,
  headerChildren,
  alignHeaderChildrenLeft,
  title,
  subTitle,
  className,
  style,
  info = '',
  icon,
  iconBg,
  tooltip,
  subHeader,
  helperText,
  closeModal,
  footer,
  noBorder,
  unrestrictHeaderHeight,
  dropdown = false,
  item = false,
  wrap = false
}: Props) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(prev => !prev);
  };

  return (
    <div
      className={classnames(
        classes.mainWrapper,
        className,
        item && classes.sub
      )}
      style={style}
    >
      {(title || subTitle) && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: noBorder ? 'none' : '1px solid #eaeaea'
          }}
          onClick={dropdown ? toggleDropdown : undefined}
        >
          <div style={{ width: '100%' }}>
            <div
              className={classnames(
                classes.headerBox,
                noBorder && classes.noBorder,
                unrestrictHeaderHeight && classes.heightAuto,
                dropdown && classes.headerClickable
              )}
            >
              {title && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    gap: '0.5rem'
                  }}
                  className={classnames(
                    unrestrictHeaderHeight && classes.heightAuto
                  )}
                >
                  {icon && (
                    <div
                      style={{ backgroundColor: iconBg || '#0080bd' }}
                      className={classes.iconBox}
                    >
                      {icon}
                    </div>
                  )}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px'
                    }}
                  >
                    <Typography
                      className={classes.title}
                      style={{ whiteSpace: wrap ? 'normal' : 'nowrap' }}
                      variant="h3"
                    >
                      {title}
                    </Typography>
                    {tooltip && (
                      <div style={{ marginTop: '-4px', marginLeft: '-8px' }}>
                        <Tooltip text={tooltip} />
                      </div>
                    )}
                    {alignHeaderChildrenLeft && headerChildren}
                  </div>
                  {!alignHeaderChildrenLeft && headerChildren}
                  {closeModal && (
                    <div style={{ cursor: 'pointer' }}>
                      <Icons.CloseIcon
                        height={24}
                        onClick={() => closeModal()}
                      />
                    </div>
                  )}
                  {helperText && (
                    <Tooltip
                      text={
                        <div>
                          {helperText}
                          <br />
                          {info}
                        </div>
                      }
                    />
                  )}
                </div>
              )}
              {subTitle && (
                <div style={{ marginTop: '0.25rem' }}>{subTitle}</div>
              )}
            </div>
            {subHeader && <div className={classes.subHeader}>{subHeader}</div>}
          </div>
          {dropdown && (
            <div style={{ marginRight: '1rem' }}>
              <ButtonExpand
                variant="contained"
                color="secondary"
                isOpen={isOpen}
              />
            </div>
          )}
        </div>
      )}

      {(isOpen || !dropdown) && children}

      {info && !helperText && <p className={classes.info}>{info}</p>}
      {footer && <p className={classes.info}>{footer}</p>}
    </div>
  );
};

export default BoxWrapper;
